import { render, staticRenderFns } from "./DomainNameservers.vue?vue&type=template&id=9caf327e&"
import script from "./DomainNameservers.vue?vue&type=script&lang=js&"
export * from "./DomainNameservers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9caf327e')) {
      api.createRecord('9caf327e', component.options)
    } else {
      api.reload('9caf327e', component.options)
    }
    module.hot.accept("./DomainNameservers.vue?vue&type=template&id=9caf327e&", function () {
      api.rerender('9caf327e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainNameservers.vue"
export default component.exports